import { useState, useEffect, useRef } from "react";
import "./App.css";

// ═══════════════════════════════════════════════════════════════
// PROFESSIONAL SVG ICONS
// ═══════════════════════════════════════════════════════════════
const SvgIcons = {
  Users: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  Building: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
      <path d="M9 22v-4h6v4" />
      <path d="M8 6h.01" /><path d="M16 6h.01" /><path d="M12 6h.01" />
      <path d="M12 10h.01" /><path d="M12 14h.01" />
      <path d="M16 10h.01" /><path d="M16 14h.01" />
      <path d="M8 10h.01" /><path d="M8 14h.01" />
    </svg>
  ),
  FileCheck: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
      <path d="m9 14 2 2 4-4" />
    </svg>
  ),
  Coins: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="8" cy="8" r="5" />
      <path d="M18 8c0 4.42-3 8-8 8" />
      <path d="M24 16c0 4.42-3 8-8 8" />
      <path d="M16 24c4.42 0 8-3 8-8" />
    </svg>
  ),
  Code: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polyline points="16 18 22 12 16 6" />
      <polyline points="8 6 2 12 8 18" />
      <line x1="12" y1="2" x2="12" y2="22" />
    </svg>
  ),
  Smartphone: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
      <line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  ),
  Target: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="6" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  ),
  Eye: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Diamond: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M2 7.5 12 2l10 5.5L12 22 2 7.5Z" />
      <path d="M2 7.5h20" />
      <path d="M12 2v20" />
    </svg>
  ),
  Handshake: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z" />
    </svg>
  ),
  Instagram: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  ),
  LinkedIn: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
      <rect x="2" y="9" width="4" height="12" />
      <circle cx="4" cy="4" r="2" />
    </svg>
  ),
  Lightning: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  ),
  Shield: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Clock: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Chart: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  CheckCircle: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  Globe: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  Megaphone: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  Briefcase: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  Rocket: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
      <path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
    </svg>
  ),
  Document: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  Settings: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
  Mail: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  ),
  Phone: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  ),
  ArrowRight: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  ),
  Check: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  Star: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  Quote: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V21z" />
      <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
    </svg>
  ),
  Car: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3 13l2-5a3 3 0 0 1 2.8-2h8.4A3 3 0 0 1 19 8l2 5" />
      <path d="M5 13h14a2 2 0 0 1 2 2v3h-3" />
      <path d="M6 18H3v-3a2 2 0 0 1 2-2" />
      <circle cx="7" cy="18" r="2" />
      <circle cx="17" cy="18" r="2" />
      <path d="M7 10h10" />
    </svg>
  ),
};

// ─── SVG Icon helper for service rows ───────────────────────────
const serviceSvgIcons = {
  recruitment: <SvgIcons.Users width="26" height="26" />,
  hr: <SvgIcons.Building width="26" height="26" />,
  compliance: <SvgIcons.FileCheck width="26" height="26" />,
  accounting: <SvgIcons.Coins width="26" height="26" />,
  webdev: <SvgIcons.Code width="26" height="26" />,
  social: <SvgIcons.Smartphone width="26" height="26" />,
};

// ─── WhatsApp helper ───────────────────────────────────────────────
const WA_NUMBER = "917709997506";
const waLink = (msg) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

const SERVICE_WA = {
  recruitment: waLink("Hello Vridhi Growth Partners! I'm interested in your Recruitment Services. Could you please share more details about candidate sourcing, screening, and hiring support?"),
  hr: waLink("Hello Vridhi Growth Partners! I'd like to know more about your HR Services including documentation, policies, and payroll support for my organization."),
  compliance: waLink("Hello Vridhi Growth Partners! I need assistance with Business Documentation & Compliance services such as MSME registration and business setup."),
  accounting: waLink("Hello Vridhi Growth Partners! I'm looking for Accounting Support Services including bookkeeping, GST support, and financial record maintenance."),
  webdev: waLink("Hello Vridhi Growth Partners! I'm interested in your Website & App Development Services. I'd love to discuss my project requirements."),
  social: waLink("Hello Vridhi Growth Partners! I want to grow my brand through your Social Media Management services. Please share more details."),
  general: waLink("Hello Vridhi Growth Partners! I'd like to learn more about your services and how you can help my business grow."),
};

// ─── Intersection Observer Hook ────────────────────────────────────
function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setInView(true); obs.disconnect(); } },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

// ─── Animated Counter ──────────────────────────────────────────────
function Counter({ target, suffix = "" }) {
  const [count, setCount] = useState(0);
  const [ref, inView] = useInView(0.3);
  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const duration = 1800;
    const step = Math.ceil(target / (duration / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(start);
    }, 16);
    return () => clearInterval(timer);
  }, [inView, target]);
  return <span ref={ref}>{count}{suffix}</span>;
}

// ─── SERVICE-SPECIFIC CONTACT FORM ────────────────────────────────
const serviceDataForForms = {
  recruitment: {
    title: "Recruitment Services",
    badge: "Hire Better",
    subtitle: "Find the perfect candidates for your team",
    placeholder: "Tell us about your hiring needs — roles, experience, industry..."
  },
  hr: {
    title: "HR Services",
    badge: "Streamline HR",
    subtitle: "Build a strong HR foundation for your business",
    placeholder: "Describe your HR requirements — policies, documentation, payroll..."
  },
  compliance: {
    title: "Business Documentation & Compliance",
    badge: "Stay Compliant",
    subtitle: "Get all registrations and compliance right",
    placeholder: "Tell us about your compliance needs — MSME, registration, etc..."
  },
  accounting: {
    title: "Accounting Support",
    badge: "Financial Clarity",
    subtitle: "Keep your finances organized and compliant",
    placeholder: "Describe your accounting requirements — bookkeeping, GST, etc..."
  },
  webdev: {
    title: "Website & App Development",
    badge: "Go Digital",
    subtitle: "Build a powerful digital presence",
    placeholder: "Tell us about your project — website, app, features, timeline..."
  },
  social: {
    title: "Social Media Management",
    badge: "Grow Online",
    subtitle: "Let us amplify your brand's voice",
    placeholder: "Tell us about your brand and social media goals..."
  },
  default: {
    title: "Book a Free Consultation",
    badge: "Free Consultation",
    subtitle: "Share your requirement and we’ll suggest the right next steps.",
    placeholder: "Tell us about your business needs — hiring, HR, compliance, accounting, website, app, or social media..."
  }
};

function ContactForm({ onClose, service = "" }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  
  const s = serviceDataForForms[service] || serviceDataForForms.default;
  
  const handleSubmit = () => {
    if (!form.name.trim() || !form.phone.trim() || !form.message.trim()) {
      alert("Please fill your name, phone number, and requirement before submitting.");
      return;
    }

    const msg = `Hello Vridhi Growth Partners!

  Name: ${form.name}
  Email: ${form.email}
  Phone: ${form.phone}
  ${service ? `Service Interested: ${s.title}
  ` : ""}Message: ${form.message}`;

    window.open(waLink(msg), "_blank");
    onClose();
  };
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <div className="modal-header">
          <div className="modal-badge">{s.badge}</div>
          <h2>{s.title}</h2>
          <p>{s.subtitle}</p>
        </div>
        <div className="modal-body">
          <input name="name" placeholder="Your Full Name *" value={form.name} onChange={handleChange} />
          <input name="email" placeholder="Email Address" value={form.email} onChange={handleChange} />
          <input name="phone" placeholder="Phone / WhatsApp Number *" value={form.phone} onChange={handleChange} />
          <textarea name="message" placeholder={`${s.placeholder} *`} rows={4} value={form.message} onChange={handleChange} />
          <button className="btn-primary" onClick={handleSubmit}>
            <span>Request Consultation via WhatsApp</span>
            <SvgIcons.ArrowRight width="20" height="20" />
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Privacy Policy Modal ──────────────────────────────────────────
function PrivacyModal({ onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card legal-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <h2>Privacy Policy</h2>
        <p className="legal-date">Effective Date: June 2025</p>
        <div className="legal-content">
          <h3>1. Information We Collect</h3>
          <p>We collect information you provide directly to us, such as your name, email address, phone number, and any messages you send through our contact forms or WhatsApp.</p>
          <h3>2. How We Use Your Information</h3>
          <p>We use your information to respond to your inquiries, provide our services, send updates about our offerings, and improve our business operations.</p>
          <h3>3. Information Sharing</h3>
          <p>We do not sell, trade, or rent your personal information to third parties. We may share information with trusted service providers who assist in operating our business, subject to confidentiality obligations.</p>
          <h3>4. Data Security</h3>
          <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, or disclosure.</p>
          <h3>5. Cookies</h3>
          <p>Our website may use cookies to enhance your browsing experience. You can disable cookies through your browser settings, though this may affect website functionality.</p>
          <h3>6. Third-Party Links</h3>
          <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices of those sites.</p>
          <h3>7. Contact Us</h3>
              <p>For privacy-related queries, contact us at: <strong>vridhigrowthpartners@gmail.com</strong> or WhatsApp: <strong>+91 7709997506</strong></p>
          <h3>8. Changes to This Policy</h3>
          <p>We may update this Privacy Policy periodically. We encourage you to review it regularly.</p>
        </div>
      </div>
    </div>
  );
}

// ─── Terms Modal ───────────────────────────────────────────────────
function TermsModal({ onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card legal-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <h2>Terms & Conditions</h2>
        <p className="legal-date">Effective Date: June 2026</p>
        <div className="legal-content">
          <h3>1. Acceptance of Terms</h3>
          <p>By accessing and using the Vridhi Growth Partners website and services, you agree to be bound by these Terms and Conditions.</p>
          <h3>2. Services</h3>
          <p>Vridhi Growth Partners provides business growth services including recruitment, HR support, compliance, accounting, web development, and social media management. Service specifics are outlined in individual agreements.</p>
          <h3>3. Client Responsibilities</h3>
          <p>Clients are responsible for providing accurate information, timely responses, and necessary documentation to enable service delivery.</p>
          <h3>4. Confidentiality</h3>
          <p>Both parties agree to maintain confidentiality of proprietary and sensitive business information shared during the engagement.</p>
          <h3>5. Payment Terms</h3>
          <p>Payment terms are specified in individual service agreements. Late payments may attract applicable charges as mutually agreed.</p>
          <h3>6. Intellectual Property</h3>
          <p>All work products created by Vridhi Growth Partners for clients become the client's property upon full payment. Our proprietary methodologies remain our intellectual property.</p>
          <h3>7. Limitation of Liability</h3>
          <p>Vridhi Growth Partners shall not be liable for indirect, incidental, or consequential damages arising from the use of our services beyond the fees paid for the specific service.</p>
          <h3>8. Termination</h3>
          <p>Either party may terminate a service agreement with 30 days written notice. Fees for work completed prior to termination remain payable.</p>
          <h3>9. Governing Law</h3>
          <p>These Terms are governed by the laws of India. Disputes shall be subject to the jurisdiction of courts in Maharashtra.</p>
          <h3>10. Contact</h3>
              <p>For queries: <strong>vridhigrowthpartners@gmail.com</strong> | WhatsApp: <strong>+91 7709997506</strong></p>
        </div>
      </div>
    </div>
  );
}

// ─── Navbar ────────────────────────────────────────────────────────
function Navbar({ page, setPage, openContact }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);
  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);
  const nav = (p) => {
    window.history.pushState({ page: p }, "", `#${p}`);
    setPage(p);
    setMenuOpen(false);
    window.scrollTo(0, 0);
  };
  const closeMenu = () => setMenuOpen(false);
  return (
    <nav className={`navbar${scrolled ? " scrolled" : ""}`}>
      <div className="nav-inner">
        <div className="nav-logo" onClick={() => nav("home")}>
          <div className="logo-mark">
            <img
              src="/logo.jpeg"
              alt="Vridhi Growth Partners logo"
              className="logo-img"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="logo-text">
            <div className="logo-name">Vridhi Growth Partners</div>
            {/* <div className="logo-sub">Growth Partners</div> */}
            <div className="logo-tagline">Your Business. Our Expertise. Your Growth.</div>
          </div>
        </div>
        {/* Mobile menu backdrop */}
        <div className={`menu-overlay${menuOpen ? " visible" : ""}`} onClick={closeMenu}></div>
        <div className={`nav-links${menuOpen ? " open" : ""}`}>
          {["home","services","projects","about"].map((p) => (
            <button key={p} className={`nav-link${page===p?" active":""}`} onClick={() => nav(p)}>
              {p.charAt(0).toUpperCase()+p.slice(1)}
            </button>
          ))}
          <button className="btn-primary small" onClick={() => { openContact(); setMenuOpen(false); }}><span>Contact Us</span></button>
        </div>
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          <span className={menuOpen?"open":""}></span>
          <span className={menuOpen?"open":""}></span>
          <span className={menuOpen?"open":""}></span>
        </button>
      </div>
    </nav>
  );
}
// ─── HOME PAGE ─────────────────────────────────────────────────────
function HomePage({ setPage, openContact }) {
  const [heroVisible, setHeroVisible] = useState(false);
  useEffect(() => { const t = setTimeout(() => setHeroVisible(true), 100); return () => clearTimeout(t); }, []);
  const [statsRef, statsInView] = useInView(0.2);
  const [aboutRef, aboutInView] = useInView(0.15);
  const [servRef, servInView] = useInView(0.1);
  const [testRef, testInView] = useInView(0.1);

  const services = [
    { icon: "recruitment", title: "Recruitment Services", desc: "Hire faster with screened candidates for white-collar and blue-collar roles.", key: "recruitment" },
    { icon: "hr", title: "HR Services", desc: "Set up employee documentation, HR policies, payroll support, and lifecycle processes.", key: "hr" },
    { icon: "compliance", title: "Business Documentation & Compliance", desc: "Get support for registrations, licenses, business documentation, and compliance needs.", key: "compliance" },
    { icon: "accounting", title: "Accounting Support", desc: "Keep your books, GST records, invoices, and financial documents organized.", key: "accounting" },
    { icon: "webdev", title: "Website & App Development", desc: "Launch a fast, professional website or app that supports your business growth.", key: "webdev" },
    { icon: "social", title: "Social Media Management", desc: "Build a consistent digital presence with content, campaigns, and platform management.", key: "social" },
  ];

  const testimonials = [
    {
      name: "Vedant Mhatre",
      company: "Vedant Travels",
      role: "Founder & Director",
      text: "Vridhi Growth Partners transformed our online presence with a professional, responsive website that improved how customers discover and connect with our travel business.",
      rating: 5
    },
    {
      name: "Startup & SME Support",
      company: "Business Services",
      role: "Growth Partner",
      text: "From hiring and HR to compliance and digital presence, Vridhi Growth Partners supports businesses with practical, end-to-end execution.",
      rating: 5
    },
    {
      name: "Personalized Execution",
      company: "Client-Focused Approach",
      role: "Extended Team Support",
      text: "Every business has different needs. Our approach focuses on understanding the requirement first and then suggesting the right solution.",
      rating: 5
    },
  ];

  const aboutCards = [
    { icon: <SvgIcons.Target width="24" height="24" />, title: "Mission", text: "To empower businesses with the right resources, talent, and tools for sustainable growth." },
    { icon: <SvgIcons.Eye width="24" height="24" />, title: "Vision", text: "To be the most trusted growth partner for emerging businesses across India." },
    { icon: <SvgIcons.Diamond width="24" height="24" />, title: "Values", text: "Integrity, excellence, innovation, and unwavering commitment to client success." },
  ];

  return (
    <div className="page">
      {/* HERO */}
      <section className="hero-section">
        <div className="hero-bg">
          <div className="hero-glow hero-glow-1"></div>
          <div className="hero-glow hero-glow-2"></div>
          <div className="hero-glow hero-glow-3"></div>
          <div className="hero-grid-overlay"></div>
        </div>
        <div className={`hero-content${heroVisible ? " visible" : ""}`}>
          <div className="hero-badge">
            <span className="hero-badge-dot"></span>
            New & Emerging Business Growth Partner
          </div>
          <h1 className="hero-title">
            Your Business <span className="gold-gradient">Our Expertise</span>{" "}<br />
            Your <span className="gold-gradient">Growth</span>
          </h1>
          <p className="hero-desc">
            Professional Business Solutions That Help You Build, Manage & Grow Your Business.
          </p>
          <p className="hero-desc">
            Supporting startups, SMEs, hospitality businesses, manufacturers, and enterprises with Recruitment, HR, Payroll, Accounting, Business Compliance, Website & App Development, E-Commerce Solutions, and Social Media Management—all under one roof.
          </p>
          <div className="hero-cta">
            <button className="btn-primary large" onClick={openContact}><span>Book a Free Consultation</span></button>
            <button className="btn-outline large" onClick={() => { window.history.pushState({ page: "services" }, "", "#services"); setPage("services"); window.scrollTo(0, 0); }}>Explore Services</button>
          </div>
          <div className="hero-scroll">
            <div className="scroll-mouse"></div>
            <span>Scroll to explore</span>
          </div>
        </div>
        <div className={`hero-visual${heroVisible ? " visible" : ""}`}>
          <svg viewBox="0 0 500 400" xmlns="http://www.w3.org/2000/svg" className="growth-svg">
            <defs>
              <linearGradient id="lineGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#D4A843" stopOpacity="0"/>
                <stop offset="50%" stopColor="#D4A843" stopOpacity="1"/>
                <stop offset="100%" stopColor="#F0D78A" stopOpacity="1"/>
              </linearGradient>
            </defs>
            <path className="growth-line" d="M30,350 Q80,300 130,280 Q180,260 200,220 Q230,170 270,150 Q310,130 340,100 Q380,60 460,30" fill="none" stroke="url(#lineGrad)" strokeWidth="3" strokeLinecap="round"/>
            {[{ cx:130, cy:280 }, { cx:200, cy:220 }, { cx:270, cy:150 }, { cx:340, cy:100 }, { cx:460, cy:30 }].map((p,i) => (
              <circle key={i} className={`growth-dot dot-${i+1}`} cx={p.cx} cy={p.cy} r="6" fill="#D4A843"/>
            ))}
            <text x="160" y="240" fill="#D4A843" fontSize="12" opacity="0.7">Growth</text>
            <text x="280" y="170" fill="#D4A843" fontSize="12" opacity="0.7">Scale</text>
            <text x="360" y="120" fill="#D4A843" fontSize="12" opacity="0.7">Success</text>
          </svg>
        </div>
      </section>

      {/* STATS */}
      <section className="stats-section" ref={statsRef}>
        <div className="container">
          <div className="stats-grid">
            {[
              { val: 6, suf: "+", label: "Service Areas" },
              { val: 5, suf: "+", label: "Industries Supported" },
              { val: 3, suf: "+", label: "Client Projects" },
              { val: 100, suf: "%", label: "Growth-Focused Approach" },
            ].map((s, i) => (
              <div key={i} className={`stat-card${statsInView ? " stagger-item visible" : " stagger-item"}`} style={{ transitionDelay: `${i * 0.12}s` }}>
                <div className="stat-num">{statsInView ? <Counter target={s.val} suffix={s.suf} /> : `0${s.suf}`}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TRUST SECTION */}
      <section className="trust-section">
        <div className="container">
          <div className="section-header">
            <span className="eyebrow">Why Choose Us</span>
            <h2>Built for Startups, SMEs, and Growing Businesses</h2>
            <p>
              We combine business understanding, practical execution, and personalized support to help companies move faster with confidence.
            </p>
          </div>

          <div className="trust-grid">
            <div className="trust-card">
              <SvgIcons.CheckCircle width="28" height="28" />
              <h3>End-to-End Support</h3>
              <p>From hiring and HR to compliance, accounting, websites, and digital growth.</p>
            </div>

            <div className="trust-card">
              <SvgIcons.Clock width="28" height="28" />
              <h3>Fast & Practical Execution</h3>
              <p>Clear processes, responsive communication, and solutions focused on real business needs.</p>
            </div>

            <div className="trust-card">
              <SvgIcons.Handshake width="28" height="28" />
              <h3>Personalized Partnership</h3>
              <p>We work like an extended team, understanding your goals before suggesting solutions.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT SNIPPET */}
      <section className="about-snippet" ref={aboutRef}>
        <div className="container">
          <div className="about-grid">
            <div className={`about-left${aboutInView ? " reveal visible" : " reveal"}`}>
              <div className="section-label">About Us</div>
              <h2>A New Generation <span className="gold-text">Growth Partner</span></h2>
              <p className="highlight">Vridhi Growth Partners is an emerging business consulting firm dedicated to helping startups, SMEs, and growing businesses achieve their full potential. We combine expertise with a personalized approach to deliver real results.</p>
              <p className="highlight">With a strong foundation in HR, Accounting, Recruitment, Compliance, and Digital services, we act as your extended team — committed to your success at every step.</p>
              <button className="btn-primary" onClick={() => { window.history.pushState({ page: "about" }, "", "#about"); setPage("about"); window.scrollTo(0, 0); }}><span>Our Story</span></button>
            </div>
            <div className={`about-right${aboutInView ? " reveal-right visible" : " reveal-right"}`}>
              <div className="about-cards">
                {aboutCards.map((c, i) => (
                  <div key={i} className="mini-card">
                    <div className="mini-icon">{c.icon}</div>
                    <div><strong>{c.title}</strong><p>{c.text}</p></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES PREVIEW */}
      <section className="services-preview" ref={servRef}>
        <div className="container">
          <div className="section-header">
            <div className="section-label" style={{ justifyContent: "center" }}>What We Do</div>
            <h2>Our <span className="gold-text">Services</span></h2>
            <p>Practical business solutions designed to support your hiring, operations, compliance, and digital growth.</p>
          </div>

          <div className="services-grid">
            {services.map((s, i) => (
              <button
                key={i}
                type="button"
                className={`service-card${servInView ? " stagger-item visible" : " stagger-item"}`}
                style={{ transitionDelay: `${i * 0.08}s` }}
                onClick={() => {
                  const nextPage = `service-${s.key}`;
                  window.history.pushState({ page: nextPage }, "", `#${nextPage}`);
                  setPage(nextPage);
                  window.scrollTo(0, 0);
                }}
              >
                <div className="service-icon">{serviceSvgIcons[s.icon]}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <div className="service-link">Learn More <span>→</span></div>
              </button>
            ))}
          </div>

          <div className="center-btn">
            <button className="btn-outline" onClick={() => { setPage("services"); window.scrollTo(0, 0); }}>
              View All Services
            </button>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="testimonials-section" ref={testRef}>
        <div className="container">
          <div className="section-header">
            <div className="section-label" style={{ justifyContent: "center" }}>Testimonials</div>
            <h2>What Our <span className="gold-text">Clients Say</span></h2>
          </div>
          <div className="test-grid">
            {testimonials.map((t, i) => (
              <div key={i} className={`test-card${testInView ? " stagger-item visible" : " stagger-item"}`} style={{ transitionDelay: `${i * 0.15}s` }}>
                <div className="stars">{"★".repeat(t.rating)}</div>
                <p className="test-text">"{t.text}"</p>
                <div className="test-author">
                  <div className="test-avatar">{t.name[0]}</div>
                  <div><strong>{t.name}</strong><span>{t.role}, {t.company}</span></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-box">
            <h2>Ready to <span className="gold-text">Grow Your Business?</span></h2>
            <p>Let's have a conversation about your goals and how Vridhi Growth Partners can help you achieve them.</p>
            <div className="cta-buttons">
              <button className="btn-primary large" onClick={openContact}><span>Book a Free Consultation</span></button>
              <a href={SERVICE_WA.general} target="_blank" rel="noopener noreferrer" className="whatsapp-float">
                <SvgIcons.Smartphone width="20" height="20" />
                <span>Chat with us</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

// ─── ABOUT PAGE ────────────────────────────────────────────────────
function AboutPage({ openContact }) {
  const [ref1, v1] = useInView();
  const [ref2, v2] = useInView();
  const [ref3, v3] = useInView();

  const valuesData = [
    { icon: <SvgIcons.Target width="28" height="28" />, title: "Our Mission", text: "To empower startups and SMEs with the right people, processes, and platforms — enabling sustainable growth and competitive advantage in their industries." },
    { icon: <SvgIcons.Eye width="28" height="28" />, title: "Our Vision", text: "To become India's most trusted growth partner for emerging businesses — known for integrity, impact, and the lasting success of our clients." },
    { icon: <SvgIcons.Diamond width="28" height="28" />, title: "Our Values", text: "Integrity in every interaction. Excellence in every deliverable. Innovation in every solution. And an unwavering commitment to our clients' long-term success." },
    { icon: <SvgIcons.Handshake width="28" height="28" />, title: "Our Promise", text: "We treat every client's business as our own. Your challenges become our challenges, your milestones become our pride, and your growth becomes our greatest achievement." },
  ];

  const teamData = [
    { name: "Vridhi Leadership Team", role: "Founders & Directors", icon: <SvgIcons.Briefcase width="32" height="32" />, desc: "A passionate team of business professionals committed to helping companies grow through strategic solutions." },
    { name: "Recruitment Specialists", role: "Talent Acquisition", icon: <SvgIcons.Users width="32" height="32" />, desc: "Expert recruiters with deep industry knowledge across hospitality, manufacturing, retail, and startups." },
    { name: "HR Consultants", role: "Human Resources", icon: <SvgIcons.Building width="32" height="32" />, desc: "Seasoned HR professionals helping businesses build strong workforce management systems." },
    {
      name: "Accounting Support Team",
      role: "Accounts & Financial Operations",
      icon: <SvgIcons.Coins width="32" height="32" />,
      desc: "Detail-oriented accounting professionals supporting businesses with bookkeeping, GST records, invoicing, financial documentation, and organized account management."
    },
    { name: "Tech & Digital Team", role: "Web & App Development", icon: <SvgIcons.Code width="32" height="32" />, desc: "Creative developers and designers building powerful digital solutions for modern businesses." },
  ];

  return (
    <div className="page">
      <section className="page-hero">
        <div className="page-hero-bg"></div>
        <div className="page-hero-content">
          <div className="section-label" style={{ justifyContent: "center" }}>About Us</div>
          <h1>Our <span className="gold-text">Story</span></h1>
          <p>A new force in business consulting, built on expertise, integrity, and a genuine passion for client success</p>
        </div>
      </section>
      <section className="about-detail" ref={ref1}>
        <div className="container">
          <div className={`about-story${v1 ? " reveal visible" : " reveal"}`}>
            <div className="story-text">
              <h2>Who We <span className="gold-text">Are</span></h2>
              <p>Vridhi Growth Partners is an emerging business consulting and services firm, founded with a clear purpose — to provide growing businesses with the expert support they need to thrive in today's competitive landscape.</p>
              <p>The name "Vridhi" (वृद्धि) means growth and prosperity in Sanskrit — and that's exactly what we stand for. We believe every business, regardless of size, deserves access to professional services that drive real growth.</p>
              <p>As a new company, we bring fresh perspectives, modern approaches, and an unwavering commitment to delivering results. Our first success story — <strong>Vedant Travels</strong> — is a testament to the quality and dedication we bring to every engagement.</p>
            </div>
            <div className="story-highlight">
              <div className="highlight-box">
                <div className="highlight-num">2026</div>
                <div className="highlight-text">Year Founded</div>
              </div>
              <div className="highlight-box gold">
                <div className="highlight-num">1</div>
                <div className="highlight-text">Successful Client Website Live</div>
              </div>
              <div className="highlight-box">
                <div className="highlight-num">6</div>
                <div className="highlight-text">Service Verticals</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="values-section" ref={ref2}>
        <div className="container">
          <div className="section-header">
            <div className="section-label" style={{ justifyContent: "center" }}>Our Foundation</div>
            <h2>What Drives <span className="gold-text">Us</span></h2>
          </div>
          <div className="values-grid">
            {valuesData.map((v,i) => (
              <div key={i} className={`value-card${v2 ? " stagger-item visible" : " stagger-item"}`} style={{transitionDelay:`${i*0.1}s`}}>
                <div className="value-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="team-section" ref={ref3}>
        <div className="container">
          <div className="section-header">
            <div className="section-label" style={{ justifyContent: "center" }}>Our Team</div>
            <h2>The People Behind <span className="gold-text">Vridhi</span></h2>
          </div>
          <div className="team-grid">
            {teamData.map((m,i) => (
              <div key={i} className={`team-card${v3 ? " stagger-item visible" : " stagger-item"}`} style={{transitionDelay:`${i*0.1}s`}}>
                <div className="team-icon">{m.icon}</div>
                <h3>{m.name}</h3>
                <span className="team-role">{m.role}</span>
                <p>{m.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="cta-section">
        <div className="container">
          <div className="cta-box">
            <h2>Ready to Partner with <span className="gold-text">Vridhi?</span></h2>
            <p>Let's build something great together. Reach out and let's start the conversation.</p>
            <button className="btn-primary large" onClick={openContact}><span>Book a Free Consultation</span></button>
          </div>
        </div>
      </section>
    </div>
  );
}

// ─── SERVICES LIST PAGE ────────────────────────────────────────────
function ServicesPage({ setPage }) {
  const [ref, inView] = useInView(0.05);
  const services = [
    { icon: "recruitment", title: "Recruitment Services", desc: "Hire faster with screened candidates for white-collar and blue-collar roles.", key: "recruitment", tags: ["White-Collar","Blue-Collar","Temporary","Contract-to-Hire"] },
    { icon: "hr", title: "HR Services", desc: "Set up employee documentation, HR policies, payroll support, and lifecycle processes.", key: "hr", tags: ["HR Policies","Documentation","Payroll","Compliance"] },
    { icon: "compliance", title: "Business Documentation & Compliance", desc: "Get support for registrations, licenses, business documentation, and compliance needs.", key: "compliance", tags: ["MSME","Registration","Compliance","Documentation"] },
    { icon: "accounting", title: "Accounting Support", desc: "Keep your books, GST records, invoices, and financial documents organized.", key: "accounting", tags: ["Bookkeeping","GST","Invoicing","Reporting"] },
    { icon: "webdev", title: "Website & App Development", desc: "Launch a fast, professional website or app that supports your business growth.", key: "webdev", tags: ["Web","Mobile","UI/UX","E-Commerce"] },
    { icon: "social", title: "Social Media Management", desc: "Build a consistent digital presence with content, campaigns, and platform management.", key: "social", tags: ["Content","Strategy","Branding","Analytics"] },
  ];
  return (
    <div className="page">
      <section className="page-hero">
        <div className="page-hero-bg"></div>
        <div className="page-hero-content">
          <div className="section-label" style={{ justifyContent: "center" }}>What We Offer</div>
          <h1>Our <span className="gold-text">Services</span></h1>
          <p>End-to-end business solutions designed to help you grow, scale, and succeed</p>
        </div>
      </section>
      <section className="services-full" ref={ref}>
        <div className="container">
          <div className="services-list">
            {services.map((s,i) => (
              <div key={i} className={`service-row${inView ? " stagger-item visible" : " stagger-item"}`} style={{transitionDelay:`${i*0.1}s`}} onClick={() => { const nextPage = `service-${s.key}`; window.history.pushState({ page: nextPage }, "", `#${nextPage}`);  setPage(nextPage); window.scrollTo(0, 0); }}>
                <div className="service-row-left">
                  <div className="service-row-svg-icon">{serviceSvgIcons[s.icon]}</div>
                  <div className="service-row-info">
                    <h3>{s.title}</h3>
                    <p>{s.desc}</p>
                    <div className="service-tags">{s.tags.map((t,j) => <span key={j} className="tag">{t}</span>)}</div>
                  </div>
                </div>
                <div className="service-row-arrow">
                  <SvgIcons.ArrowRight width="20" height="20" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

// ─── INDIVIDUAL SERVICE PAGE ───────────────────────────────────────
function ServiceDetailPage({ serviceKey, openContact }) {
  const [ref1, v1] = useInView();
  const serviceData = {
    recruitment: {
      svgIcon: <SvgIcons.Users width="56" height="56" />,
      icon:"👥", title:"Recruitment Services", subtitle:"Build the right team with professional recruitment solutions.",
      color:"#D4A843",
      intro:"Vridhi Growth Partners helps businesses hire qualified and skilled professionals across various industries. We support White-Collar and Blue-Collar hiring through a structured, efficient recruitment process that saves you time and ensures quality.",
      services:["Candidate Sourcing","Resume Screening","Candidate Shortlisting","Interview Coordination","Joining Support"],
      industries:["Hospitality","Manufacturing","Society Management","Retail","Startups & SMEs","Corporate & IT", "Logistics & Supply Chain","Engineering & Construction","Healthcare"],
      waKey:"recruitment",
      benefits:[
        { icon: <SvgIcons.Lightning width="22" height="22" />, title:"Fast Turnaround", text:"Qualified candidates delivered within agreed timelines." },
        { icon: <SvgIcons.Target width="22" height="22" />, title:"Quality First", text:"Rigorous screening ensures only the best candidates are shortlisted." },
        { icon: <SvgIcons.Handshake width="22" height="22" />, title:"End-to-End Support", text:"From sourcing to joining, we handle the complete recruitment cycle." },
      ]
    },
    hr: {
      svgIcon: <SvgIcons.Building width="56" height="56" />,
      icon:"🏢", title:"HR Services", subtitle:"Professional HR support for growing businesses.",
      color:"#2D3561",
      intro:"We assist organizations in creating HR policies, employee documentation, and compliance-related documents to ensure smooth, professional workforce management. From startup HR setup to ongoing HR advisory, we've got you covered.",
      services:["HR Documentation","HR Policies & Processes","Employee Lifecycle Management","Startup HR Setup","Compliance Support","HR Advisory","Payroll Support"],
      industries:["Startups & SMEs","Hospitality","Manufacturing","Service Industries","Corporate & IT","Retail","Logistics & Supply Chain","Engineering & Construction","Society & Facility Management","Healthcare"],
      waKey:"hr",
      benefits:[
        { icon: <SvgIcons.Document width="22" height="22" />, title:"Complete Documentation", text:"All your HR docs, policies, and processes professionally crafted." },
        { icon: <SvgIcons.Shield width="22" height="22" />, title:"Compliance Ready", text:"Stay legally compliant with proper HR structures in place." },
        { icon: <SvgIcons.Rocket width="22" height="22" />, title:"Quick Setup", text:"Get your HR framework up and running rapidly." },
      ]
    },
    compliance: {
      svgIcon: <SvgIcons.FileCheck width="56" height="56" />,
      icon:"📋", title:"Business Documentation & Compliance", subtitle:"Helping businesses stay compliant and organized.",
      color:"#1a472a",
      intro:"We support startups and businesses with essential registrations and documentation required for smooth operations. Navigate the complex landscape of Indian business compliance with our expert guidance.",
      services:["MSME Registration","Shop & Establishment Registration","Basic Business Documentation","Compliance Assistance","Vendor Documentation"],
      industries:["Startups","Retail","Manufacturing","Service Sector","SMEs"],
      waKey:"compliance",
      benefits:[
        { icon: <SvgIcons.CheckCircle width="22" height="22" />, title:"100% Compliant", text:"Ensure all registrations and documents are legally sound." },
        { icon: <SvgIcons.Clock width="22" height="22" />, title:"Time Saving", text:"We handle the paperwork so you can focus on your business." },
        { icon: <SvgIcons.Shield width="22" height="22" />, title:"Risk Free", text:"Avoid penalties and legal issues with proper compliance." },
      ]
    },
    accounting: {
      svgIcon: <SvgIcons.Coins width="56" height="56" />,
      icon:"📊", title:"Accounting Support Services", subtitle:"Reliable accounting support for businesses.",
      color:"#7B2D8B",
      intro:"Our accounting solutions help businesses manage financial records, reporting, and day-to-day accounting activities efficiently. Whether you're a startup or established business, we provide the financial clarity you need.",
      services:["Bookkeeping","GST Support","Invoice Management","Financial Record Maintenance","Accounts Assistance"],
      industries:["Startups & SMEs","Retail & E-Commerce","Manufacturing","Hospitality","Corporate & IT","Logistics & Supply Chain","Society & Facility Management","Healthcare"],
      waKey:"accounting",
      benefits:[
        { icon: <SvgIcons.Chart width="22" height="22" />, title:"Clear Financials", text:"Accurate, up-to-date financial records at all times." },
        { icon: <SvgIcons.CheckCircle width="22" height="22" />, title:"GST Compliance", text:"Timely GST filing and compliance management." },
        { icon: <SvgIcons.Eye width="22" height="22" />, title:"Financial Clarity", text:"Understand your business finances with clear reporting." },
      ]
    },
    webdev: {
      svgIcon: <SvgIcons.Code width="56" height="56" />,
      icon:"💻", title:"Website & App Development", subtitle:"Transform Your Business with Powerful Digital Solutions.",
      color:"#1565C0",
      intro:"At Vridhi Growth Partners, we help businesses establish a strong digital presence through professional website and mobile application development services. Our solutions are designed to enhance customer engagement, streamline operations, and support business growth.",
      services:["Business Websites","Corporate Websites","E-Commerce Websites","Portfolio Websites","Landing Pages","Website Redesign & Maintenance","SEO-Friendly Development","Mobile Responsive Design","Android App Development","iOS App Development","Business Applications","E-Commerce Apps","Service Booking Apps","Custom Mobile Applications","App Maintenance & Support"],
      industries:["Retail & E-Commerce","Travel & Hospitality","Healthcare","Education","Startups & SMEs"],
      waKey:"webdev",
      benefits:[
        { icon: <SvgIcons.Globe width="22" height="22" />, title:"Modern Design", text:"Professional, responsive websites that impress visitors." },
        { icon: <SvgIcons.Smartphone width="22" height="22" />, title:"Mobile First", text:"Optimized for all devices — mobile, tablet, and desktop." },
        { icon: <SvgIcons.Eye width="22" height="22" />, title:"SEO Ready", text:"Built with search engine optimization best practices." },
      ],
      caseStudy: { name:"Vedant Travels", url:"https://vedantgo.in", desc:"Our first successful client — a professional travel booking website with modern design, seamless navigation, and mobile-responsive layout." }
    },
    social: {
      svgIcon: <SvgIcons.Smartphone width="56" height="56" />,
      icon:"📱", title:"Social Media Management", subtitle:"Grow your brand through effective social media presence.",
      color:"#C62828",
      intro:"We help businesses build brand awareness, engage customers, and generate leads through strategic social media management. From content creation to performance monitoring, we handle your entire social media presence.",
      services:["Content Creation","Social Media Post Design","Account Management","Brand Promotion","Performance Monitoring"],
      industries:["Retail","Food & Beverage","Fashion","Real Estate","Startups"],
      waKey:"social",
      benefits:[
        { icon: <SvgIcons.Megaphone width="22" height="22" />, title:"Brand Awareness", text:"Build a strong, recognizable brand across all social platforms." },
        { icon: <SvgIcons.Users width="22" height="22" />, title:"Engagement", text:"Foster genuine connections with your target audience." },
        { icon: <SvgIcons.Chart width="22" height="22" />, title:"Measurable Results", text:"Track growth and ROI with detailed performance reports." },
      ]
    }
  };
  const s = serviceData[serviceKey];
  if (!s) return null;
  return (
    <div className="page">
      <section className="service-hero" style={{ "--accent": s.color }}>
        <div className="page-hero-bg"></div>
        <div className="page-hero-content">
          <div className="service-hero-icon">{s.svgIcon}</div>
          <div className="section-label" style={{ justifyContent: "center" }}>Our Services</div>
          <h1><span className="gold-text">{s.title}</span></h1>
          <p>{s.subtitle}</p>
          <div className="hero-cta">
            <button className="btn-primary large" onClick={openContact}><span>Request This Service</span></button>
            <a href={SERVICE_WA[s.waKey]} target="_blank" rel="noopener noreferrer" className="btn-wa">WhatsApp Us</a>
          </div>
        </div>
      </section>
      <section className="service-detail-main" ref={ref1}>
        <div className="container">
          <div className={`service-detail-grid${v1 ? " reveal visible" : " reveal"}`}>
            <div className="service-detail-left">
              <h2>About This <span className="gold-text">Service</span></h2>
              <p className="service-intro">{s.intro}</p>
              {s.caseStudy && (
                <div className="case-study-box">
                  <div className="case-badge">
                    <SvgIcons.CheckCircle width="14" height="14" style={{display:"inline",marginRight:"4px"}} />
                    Live Project
                  </div>
                  <h3>{s.caseStudy.name}</h3>
                  <p>{s.caseStudy.desc}</p>
                  <a href={s.caseStudy.url} target="_blank" rel="noopener noreferrer" className="btn-primary small"><span>Visit Website →</span></a>
                </div>
              )}
              <h3>What We Offer</h3>
              <ul className="service-list">
                {s.services.map((item,i) => <li key={i}><span className="check"><SvgIcons.Check width="12" height="12" /></span>{item}</li>)}
              </ul>
              <h3>Industries We Serve</h3>
              <div className="industry-tags">
                {s.industries.map((ind,i) => <span key={i} className="industry-tag">{ind}</span>)}
              </div>
            </div>
            <div className="service-detail-right">
              <div className="benefits-box">
                <h3>Why Choose Us?</h3>
                {s.benefits.map((b,i) => (
                  <div key={i} className="benefit-item">
                    <div className="benefit-icon">{b.icon}</div>
                    <div><strong>{b.title}</strong><p>{b.text}</p></div>
                  </div>
                ))}
              </div>
              <div className="contact-sidebar">
                <h3>Request a Free Quote</h3>
                <p>Interested in {s.title}? Share your requirement and we’ll guide you with the next steps.</p>
                <button className="btn-primary full-width" onClick={openContact}>
                  <span>Request Quote</span>
                </button>
                <a href={SERVICE_WA[s.waKey]} target="_blank" rel="noopener noreferrer" className="btn-wa full-width mt-8">
                  <SvgIcons.Smartphone width="18" height="18" />
                  Chat on WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

// ─── PROJECT ENQUIRY FORM ──────────────────────────────────────────
function ProjectForm({ onClose }) {
    const [form, setForm] = useState({
      name: "",
      email: "",
      phone: "",
      company: "",
      serviceRequired: "",
      message: ""
    });

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = () => {
      if (
        !form.name.trim() ||
        !form.phone.trim() ||
        !form.serviceRequired.trim() ||
        !form.message.trim()
      ) {
        alert("Please fill your name, phone number, service required, and requirement details before submitting.");
        return;
      }

      const msg = `Hello Vridhi Growth Partners!

  I'd like to discuss a business requirement.

  Name: ${form.name}
  Email: ${form.email}
  Phone: ${form.phone}
  Company: ${form.company}
  Service Required: ${form.serviceRequired}
  Requirement Details: ${form.message}`;

      window.open(waLink(msg), "_blank");
      onClose();
    };

    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-card" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close" onClick={onClose}>✕</button>

          <div className="modal-header">
            <div className="modal-badge">Let's Discuss</div>
            <h2>Tell Us Your Requirement</h2>
            <p>Share your business need and we’ll connect with you on WhatsApp with the right next steps.</p>
          </div>

          <div className="modal-body">
            <input
              name="name"
              placeholder="Your Full Name *"
              value={form.name}
              onChange={handleChange}
            />

            <input
              name="email"
              placeholder="Email Address"
              value={form.email}
              onChange={handleChange}
            />

            <input
              name="phone"
              placeholder="Phone / WhatsApp Number *"
              value={form.phone}
              onChange={handleChange}
            />

            <input
              name="company"
              placeholder="Company / Business Name"
              value={form.company}
              onChange={handleChange}
            />

            <select
              name="serviceRequired"
              value={form.serviceRequired}
              onChange={handleChange}
              className="form-select"
            >
              <option value="">Select Service Required *</option>
              <option value="Website Development">Website Development</option>
              <option value="Mobile App Development">Mobile App Development</option>
              <option value="E-Commerce Store">E-Commerce Store</option>
              <option value="Branding & Design">Branding & Design</option>
              <option value="Social Media Management">Social Media Management</option>
              <option value="Recruitment Services">Recruitment Services</option>
              <option value="HR Services">HR Services</option>
              <option value="Compliance & Documentation">Compliance & Documentation</option>
              <option value="Accounting Support">Accounting Support</option>
              <option value="Other Business Support">Other Business Support</option>
            </select>

            <textarea
              name="message"
              placeholder="Describe your requirement — goals, current challenge, timeline, or support needed... *"
              rows={4}
              value={form.message}
              onChange={handleChange}
            />

            <button className="btn-primary" onClick={handleSubmit}>
              <span>Request Consultation</span>
              <SvgIcons.ArrowRight width="20" height="20" />
            </button>
          </div>
        </div>
      </div>
    );
  }

// ─── PROJECTS PAGE ─────────────────────────────────────────────────
function ProjectsPage({ openContact }) {
  const [ref, inView] = useInView(0.1);
  const [projectFormOpen, setProjectFormOpen] = useState(false);
  return (
    <div className="page">
      <section className="page-hero">
        <div className="page-hero-bg"></div>
        <div className="page-hero-content">
          <div className="section-label" style={{ justifyContent: "center" }}>Our Work</div>
          <h1>Our <span className="gold-text">Projects</span></h1>
          <p>Real results for real businesses — our growing portfolio of success stories</p>
        </div>
      </section>
      <section className="projects-section" ref={ref}>
        <div className="container">
          <div className="projects-intro">
            <h2>Our First <span className="gold-text">Success Story</span></h2>
            <p>As an emerging company, we are proud to present our first completed project — a fully functional, professional website for Vedant Travels.</p>
          </div>
          <div className={`project-showcase${inView ? " reveal visible" : " reveal"}`}>
            <div className="project-card featured">
              <div className="project-badge">
                <SvgIcons.CheckCircle width="12" height="12" style={{display:"inline",marginRight:"4px"}} />
                Live & Active
              </div>
              <div className="project-icon svg-project-icon">
                <SvgIcons.Car width="64" height="64" />
              </div>
              <div className="project-info">
                <h2>Vedant Travels</h2>
                <p className="project-tagline">Professional Travel Booking Website</p>
                <p className="project-desc">Vedant Travels approached Vridhi Growth Partners to build a professional online presence for their travel business. We delivered a fully responsive, modern website with seamless navigation, service listings, contact integration, and a user-friendly booking experience.</p>
                <div className="project-tech">
                  <span>✓ Responsive Design</span>
                  <span>✓ Modern UI/UX</span>
                  <span>✓ Fast Loading</span>
                  <span>✓ Mobile Optimized</span>
                  <span>✓ SEO Friendly</span>
                </div>
                <div className="project-result">
                  <div className="result-item"><strong>Client</strong><span>Vedant Travels</span></div>
                  <div className="result-item"><strong>Service</strong><span>Website Development</span></div>
                  <div className="result-item"><strong>Status</strong><span className="status-live">🟢 Live</span></div>
                </div>
                <a href="https://vedantgo.in" target="_blank" rel="noopener noreferrer" className="btn-primary large">
                  <span>Visit vedantgo.in →</span>
                </a>
              </div>
            </div>
          </div>
          <div className="cta-box">
            <h2>Want to be Our Next <span className="gold-text">Success Story?</span></h2>
            <p>Let's discuss your project and build something amazing together.</p>
            <button className="btn-primary large" onClick={() => setProjectFormOpen(true)}><span>Request Project Consultation</span></button>
          </div>
        </div>
      </section>
      {projectFormOpen && <ProjectForm onClose={() => setProjectFormOpen(false)} />}
    </div>
  );
}

// ─── SCROLL TO TOP BUTTON ────────────────────────────────────────────
function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const fn = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <button className={`scroll-to-top${visible ? " visible" : ""}`} onClick={scrollToTop} aria-label="Scroll to top">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="18 15 12 9 6 15" />
      </svg>
    </button>
  );
}

// ─── BACKGROUND PARTICLES ──────────────────────────────────────────
function BackgroundParticles() {
  return (
    <div className="particles-container" aria-hidden="true">
      <div className="particle"></div>
      <div className="particle"></div>
      <div className="particle"></div>
      <div className="particle"></div>
      <div className="particle"></div>
      <div className="particle"></div>
      <div className="particle"></div>
      <div className="particle"></div>
      <div className="particle"></div>
      <div className="particle"></div>
    </div>
  );
}

// ─── FOOTER ────────────────────────────────────────────────────────
function Footer({ setPage, openPrivacy, openTerms, openContact }) {
  const services = [
    { label:"Recruitment", key:"recruitment" },
    { label:"HR Services", key:"hr" },
    { label:"Compliance", key:"compliance" },
    { label:"Accounting", key:"accounting" },
    { label:"Web & App Dev", key:"webdev" },
    { label:"Social Media", key:"social" },
  ];
  const nav = (p) => {
    window.history.pushState({ page: p }, "", `#${p}`);
    setPage(p);
    window.scrollTo(0, 0);
  };
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <div className="footer-logo">
                <div className="logo-mark">
                  <img
                    src="/logo.jpeg"
                    alt="Vridhi Growth Partners logo"
                    className="logo-img"
                    loading="eager"
                    decoding="async"
                  />
                </div>
                <div className="logo-text">
                  <div className="logo-name">Vridhi Growth Partners</div>
                  {/*<div className="logo-sub">Growth Partners</div>*/}
                  <div className="logo-tagline">Your Business. Our Expertise. Your Growth.</div>
                </div>
              </div>
              <p>An emerging business consulting firm helping startups and SMEs grow through expert Recruitment, HR, Accounting, Compliance, Digital, and Marketing services.</p>
              <button className="footer-cta" onClick={openContact}>
                Book a Free Consultation
              </button>
              <div className="footer-social">
                <a href={SERVICE_WA.general} target="_blank" rel="noopener noreferrer" className="social-btn wa" title="WhatsApp">
                  <SvgIcons.Smartphone width="18" height="18" />
                  WhatsApp
                </a>
                <a href="https://www.instagram.com/vridhi_growthpartners" target="_blank" rel="noopener noreferrer" className="social-btn ig" title="Instagram">
                  <SvgIcons.Instagram width="18" height="18" />
                  Instagram
                </a>
                <a href="https://www.linkedin.com/company/vridhi-growth-partners/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="social-btn li" title="LinkedIn">
                  <SvgIcons.LinkedIn width="18" height="18" />
                  LinkedIn
                </a>
              </div>
            </div>
            <div className="footer-col">
              <h4>Quick Links</h4>
              <ul>
                {["home","about","services","projects"].map(p => (
                  <li key={p}><button onClick={() => nav(p)}>{p.charAt(0).toUpperCase()+p.slice(1)}</button></li>
                ))}
              </ul>
            </div>
            <div className="footer-col">
              <h4>Our Services</h4>
              <ul>
                {services.map(s => (
                  <li key={s.key}><button onClick={() => nav(`service-${s.key}`)}>{s.label}</button></li>
                ))}
              </ul>
            </div>
            <div className="footer-col">
              <h4>Contact Us</h4>
              <div className="footer-contact">
                <div className="contact-item">
                  <SvgIcons.Phone width="18" height="18" />
                  <a href={SERVICE_WA.general} target="_blank" rel="noopener noreferrer">+91 7709997506</a>
                </div>
                <div className="contact-item">
                  <SvgIcons.Mail width="18" height="18" />
                  <a href="mailto:info@vridhigrowthpartners.in">info@vridhigrowthpartners.in</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-inner">
            <p>© 2026 Vridhi Growth Partners. All rights reserved.</p>
            <div className="footer-legal">
              <button onClick={openPrivacy}>Privacy Policy</button>
              <span>|</span>
              <button onClick={openTerms}>Terms & Conditions</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

// ─── ROOT APP ──────────────────────────────────────────────────────
/*
const STORAGE_KEY = "vridhi_page";

function usePersistedState(defaultValue) {
  const [state, setState] = useState(() => {
    try {
      const saved = sessionStorage.getItem(STORAGE_KEY);
      return saved || defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(STORAGE_KEY, state);
    } catch {}
  }, [state]);

  return [state, setState];
}

export default function App() {
  const [page, setPage] = usePersistedState("home");
  */
const getInitialPage = () => {
  const hashPage = window.location.hash.replace("#", "");
  return hashPage || "home";
};

export default function App() {
  const [page, setPage] = useState(getInitialPage);
  const [contactOpen, setContactOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [contactService, setContactService] = useState("");

  const openContact = (service = "") => {
    setContactService(service);
    setContactOpen(true);
  };

  const serviceKey = page.startsWith("service-") ? page.replace("service-","") : null;

  const serviceNames = { recruitment:"Recruitment Services", hr:"HR Services", compliance:"Business Documentation & Compliance", accounting:"Accounting Support Services", webdev:"Website & App Development", social:"Social Media Management" };

  useEffect(() => {
    const serviceTitles = {
      recruitment: "Recruitment Services",
      hr: "HR Services",
      compliance: "Business Documentation & Compliance",
      accounting: "Accounting Support Services",
      webdev: "Website & App Development",
      social: "Social Media Management",
    };

    const pageTitles = {
      home: "Vridhi Growth Partners | Business Growth Consulting",
      about: "About Us | Vridhi Growth Partners",
      services: "Services | Vridhi Growth Partners",
      projects: "Projects | Vridhi Growth Partners",
    };

    if (serviceKey && serviceTitles[serviceKey]) {
      document.title = `${serviceTitles[serviceKey]} | Vridhi Growth Partners`;
    } else {
      document.title = pageTitles[page] || "Vridhi Growth Partners | Business Growth Consulting";
    }
  }, [page, serviceKey]);

  useEffect(() => {
    const currentHash = window.location.hash.replace("#", "");
    const initialPage = currentHash || "home";

    setPage(initialPage);
    window.history.replaceState({ page: initialPage }, "", `#${initialPage}`);

    const handleUrlChange = (event) => {
      const pageFromState = event.state?.page;
      const pageFromHash = window.location.hash.replace("#", "");

      setPage(pageFromState || pageFromHash || "home");
      window.scrollTo(0, 0);
    };

    window.addEventListener("popstate", handleUrlChange);
    window.addEventListener("hashchange", handleUrlChange);

    return () => {
      window.removeEventListener("popstate", handleUrlChange);
      window.removeEventListener("hashchange", handleUrlChange);
    };
  }, []);

  return (
    <div className="app">
      <BackgroundParticles />
      <Navbar page={page} setPage={setPage} openContact={() => openContact()} />
      {page === "home" && <HomePage setPage={setPage} openContact={() => openContact()} />}
      {page === "about" && <AboutPage openContact={() => openContact()} />}
      {page === "services" && <ServicesPage setPage={setPage} />}
      {page === "projects" && <ProjectsPage openContact={() => openContact()} />}
      {serviceKey && <ServiceDetailPage serviceKey={serviceKey} openContact={() => openContact(serviceKey)} />}
      <Footer
        setPage={setPage}
        openPrivacy={() => setPrivacyOpen(true)}
        openTerms={() => setTermsOpen(true)}
        openContact={() => openContact()}
      />
      <ScrollToTop />
      {contactOpen && <ContactForm onClose={() => setContactOpen(false)} service={contactService || (serviceKey ? serviceNames[serviceKey] ? serviceKey : "" : "")} />}
      {privacyOpen && <PrivacyModal onClose={() => setPrivacyOpen(false)} />}
      {termsOpen && <TermsModal onClose={() => setTermsOpen(false)} />}
    </div>
  );
}